import * as Bluebird from "bluebird";
var VoicemailPlayer = /** @class */ (function () {
    function VoicemailPlayer(recordings) {
        var _this = this;
        this.playing = false;
        this.loaded = false;
        this.recordings = [];
        this.recordPlayingIndex = 0;
        this.loadingPromises = [];
        this.positionRAFListener = [];
        this.positionListener = function () {
            var position = _this.getPosition();
            _this.positionRAFListener.forEach(function (func) { return func(position); });
            if (_this.isPlaying()) {
                window.requestAnimationFrame(_this.positionListener);
            }
        };
        this.onPositionUpdateRAF = function (listener) { return _this.positionRAFListener.push(listener); };
        this.seekTo = function (time) {
            var timeInTrack = time;
            var recordPlayingIndex = _this.recordings.findIndex(function (_a) {
                var duration = _a.duration;
                if (timeInTrack < duration) {
                    return true;
                }
                timeInTrack -= duration;
                return false;
            });
            if (recordPlayingIndex === -1) {
                return;
            }
            _this.recordPlayingIndex = recordPlayingIndex;
            _this.recordings[_this.recordPlayingIndex].audio.currentTime = timeInTrack;
            _this.positionListener();
            if (_this.isPlaying()) {
                _this.recordings.forEach(function (_a, index) {
                    var audio = _a.audio;
                    if (index !== recordPlayingIndex) {
                        audio.pause();
                        audio.currentTime = 0;
                    }
                });
                _this.recordings[_this.recordPlayingIndex].audio.play();
            }
        };
        this.awaitLoading = function () {
            return Bluebird.all(_this.loadingPromises);
        };
        this.isLoaded = function () { return _this.loaded; };
        this.onEnded = function () {
            if (_this.isPlaying()) {
                // Use a Promise to trigger the angular zone. Zones are bad. Angular DI is bad.
                Bluebird.resolve().then(function () {
                    _this.recordPlayingIndex += 1;
                    if (_this.recordPlayingIndex >= _this.recordings.length) {
                        _this.reset();
                        return;
                    }
                    _this.recordings[_this.recordPlayingIndex].audio.play();
                });
            }
        };
        recordings.map(function (_a) {
            var url = _a.url, estimatedDuration = _a.estimatedDuration;
            return _this.addRecording(url, estimatedDuration);
        });
    }
    VoicemailPlayer.prototype.play = function () {
        if (VoicemailPlayer.activePlayer) {
            VoicemailPlayer.activePlayer.pause();
        }
        this.recordings[this.recordPlayingIndex].audio.play();
        VoicemailPlayer.activePlayer = this;
        this.playing = true;
        this.loaded = true;
        this.positionListener();
    };
    VoicemailPlayer.prototype.pause = function () {
        this.recordings[this.recordPlayingIndex].audio.pause();
        VoicemailPlayer.activePlayer = null;
        this.playing = false;
    };
    VoicemailPlayer.prototype.toggle = function () {
        if (this.playing) {
            this.pause();
        }
        else {
            this.play();
        }
    };
    VoicemailPlayer.prototype.isPlaying = function () {
        return this.playing;
    };
    VoicemailPlayer.prototype.isPaused = function () {
        return !this.playing;
    };
    VoicemailPlayer.prototype.getDuration = function (beforeIndex) {
        return this.recordings.slice(0, beforeIndex).reduce(function (prev, next) { return prev + next.duration; }, 0);
    };
    VoicemailPlayer.prototype.getPosition = function () {
        var currentDuration = this.getDuration(this.recordPlayingIndex);
        return currentDuration + this.recordings[this.recordPlayingIndex].audio.currentTime;
    };
    VoicemailPlayer.prototype.reset = function () {
        this.recordings.forEach(function (_a) {
            var audio = _a.audio;
            audio.pause();
            audio.currentTime = 0;
        });
        this.recordPlayingIndex = 0;
        if (VoicemailPlayer.activePlayer && this !== VoicemailPlayer.activePlayer) {
            VoicemailPlayer.activePlayer.reset();
        }
        VoicemailPlayer.activePlayer = null;
        this.playing = false;
    };
    VoicemailPlayer.prototype.addRecording = function (url, duration) {
        var audio = new Audio(url);
        var audioInfo = {
            url: url,
            audio: audio,
            duration: duration
        };
        audio.addEventListener("ended", this.onEnded);
        var loadingPromise = new Bluebird(function (resolve) { return audio.addEventListener("canplaythrough", resolve); });
        this.loadingPromises.push(loadingPromise);
        this.recordings.push(audioInfo);
    };
    VoicemailPlayer.prototype.destroy = function () {
        this.recordings.forEach(function (_a) {
            var audio = _a.audio, url = _a.url;
            audio.src = "";
            audio.load();
            // TODO delete file created!
            console.warn("TODO: delete file:", url);
        });
    };
    VoicemailPlayer.prototype.getRecordings = function () {
        return this.recordings.slice();
    };
    VoicemailPlayer.activePlayer = null;
    return VoicemailPlayer;
}());
export default VoicemailPlayer;



//////////////////
// WEBPACK FOOTER
// ./js/asset/voicemailPlayer.ts
// module id = null
// module chunks = 